import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CustomNavbar from './Components/CustomNavbar';
import AboutMePage from './Pages/AboutMePage';
import './App.css'
import ProjectsPage from './Pages/ProjectsPage';
import ContactMe from './Pages/ContactMe';


const App = () => {
    return (
        <>
            <BrowserRouter>
                <CustomNavbar />
                <div className="container mt-4">
                    <Routes>
                        <Route exact path="/" element={<AboutMePage />} />
                        <Route exact path="/projects" element={<ProjectsPage />} />
                        <Route exact path="/contact" element={<ContactMe />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </>
    )
}

export default App